import { render, staticRenderFns } from "./TelegramChatsByManager.vue?vue&type=template&id=22e66116&lang=pug&"
import script from "./TelegramChatsByManager.vue?vue&type=script&lang=js&"
export * from "./TelegramChatsByManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports